import { Link as GatsbyBaseLink } from 'gatsby';
import styled, { css } from 'styled-components';

const Link = styled(GatsbyBaseLink)<
    typeof GatsbyBaseLink & { colorScheme?: 'primary' }
>`
    ${({ theme, colorScheme }) => {
        return css`
            color: ${colorScheme
                ? theme.colors[colorScheme].main
                : 'currentColor'};
            text-decoration: underline;
            text-underline-offset: 2px;
            transition: text-underline-offset 120ms ease;
            &:hover {
                text-underline-offset: 3px;
                text-decoration-thickness: 2px;
            }
        `;
    }}
`;

export default Link;
